export const PHONE_NUMBER_LIST = {
    DG: '1-800-721-7987',
    IL: '1-800-367-6401',
    TX: '1-877-442-4207',
    OK: '1-888-381-9727',
    NM: '1-877-723-5697',
    MT: '1-866-739-4090',
    MI: '1-855-649-9648'
};
